import * as prismic from '@prismicio/client';
import * as prismicNext from '@prismicio/next';
import config from './slicemachine.config.json';

/**
 * The project's Prismic repository name.
 */
export const repositoryName = config.repositoryName;

/**
 * A list of Route Resolver objects that define how a document's `url` field is resolved.
 *
 * {@link https://prismic.io/docs/route-resolver#route-resolver}
 */
// TODO: Update the routes array to match your project's route structure.
const routes: prismic.ClientConfig['routes'] = [
    {
        type: 'collection',
        path: '/collections/:uid',
    },
    {
        type: 'product',
        path: '/products/:uid',
    },
    {
        type: 'landing_page',
        path: '/:uid',
    },
    {
        type: 'story_page',
        path: '/stories/:uid',
    },
];

/**
 * Creates a Prismic client for the project's repository. The client is used to
 * query content from the Prismic API.
 *
 * @param config - Configuration for the Prismic client.
 */
export const createClient = (config: prismicNext.CreateClientConfig = {}) => {
    const client = prismic.createClient(repositoryName, {
        routes,
        fetchOptions:
            process.env.NODE_ENV === 'production'
                ? {
                      next: {
                          revalidate: 30,
                          tags: [
                              'prismic',
                              'collections',
                              'products',
                              'landing_pages',
                              'stories',
                          ],
                      },
                      // cache: 'force-cache',
                  }
                : { next: { revalidate: 5 } },
        ...config,
    });

    prismicNext.enableAutoPreviews({
        client,
        previewData: config.previewData,
        req: config.req,
    });

    return client;
};
